if (!customElements.get("slideshow-component")) {
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super()
      this.selectors = {
        contents: ['.f-slideshow__content-wrapper'],
        selected: '.selected',
        flickity: 'flickity-component',
        pageDots: '.flickity-page-dots',
        pageCounter: '.flickity-page-counter'
      }
      this.domNodes = queryDomNodes(this.selectors, this)
      this.prevIndex = 0
      this.pendingIndex = 0
      this.isTransitioning = false
      this.transitionFallback = null
      this.handleTransitionClick = this.handleTransitionClick.bind(this)
      this.addEventListener('click', this.handleTransitionClick, true)
      this.init()
    }
    
    disconnectedCallback() {
      clearInterval(this.check)
      clearTimeout(this.transitionFallback)
      this.removeEventListener('click', this.handleTransitionClick, true)
    }

    init() {
      this.check = setInterval(() => {
        this.slider = this.domNodes.flickity.slider && this.domNodes.flickity.slider.instance
        if (this.slider && typeof this.slider == 'object') {
          clearInterval(this.check)
          this.removeAttribute('data-media-loading')
          this.slider.on('change', this.handleChange.bind(this))
          this.slider.on('settle', this.handleSettle.bind(this))

          const initialIndex = Number.isInteger(this.slider.selectedIndex) ? this.slider.selectedIndex : 0
          this.prevIndex = initialIndex
          this.pendingIndex = initialIndex
          this.domNodes.contents.forEach((item, index) => {
            item.classList.remove('f-slideshow__content--out')
            item.classList.toggle('selected', index === initialIndex)
          })

          this.handleScreenChange()
          this.playVideo()
          if (this.domNodes.pageCounter) {
            this.domNodes.flickity.insertBefore(this.domNodes.pageCounter, null)
          }
        }
      }, 100)
    }

    handleChange(index) {
      const slideContentCurrent = this.domNodes.contents[index]
      if (!slideContentCurrent) return

      this.isTransitioning = true
      this.pendingIndex = index
      clearTimeout(this.transitionFallback)
      this.transitionFallback = setTimeout(() => this.finishTransition(), 1200)

      const sliderCounterCurrent = this.querySelector('.flickity-counter--current')
      const currentTextColor = slideContentCurrent.dataset.textColor
      this.style.setProperty('--slider-controls-color', currentTextColor)

      const previousIndex = this.prevIndex
      this.domNodes.contents.forEach(item => item.classList.remove('selected'))
      if (this.domNodes.contents[previousIndex]) {
        this.domNodes.contents[previousIndex].classList.add('f-slideshow__content--out')
      }
      slideContentCurrent.classList.add('selected')
      this.prevIndex = index

      setTimeout(() => {
        if (this.domNodes.contents[previousIndex]) {
          this.domNodes.contents[previousIndex].classList.remove('f-slideshow__content--out')
        }
      }, 300)

      if (this.domNodes.pageCounter && sliderCounterCurrent) {
        sliderCounterCurrent.textContent = index + 1
      }
      
      this.playVideo()
    }

    handleSettle() {
      this.finishTransition()
    }

    finishTransition() {
      clearTimeout(this.transitionFallback)
      const settledIndex = Number.isInteger(this.slider && this.slider.selectedIndex)
        ? this.slider.selectedIndex
        : this.pendingIndex

      this.domNodes.contents.forEach((item, index) => {
        item.classList.remove('f-slideshow__content--out')
        item.classList.toggle('selected', index === settledIndex)
      })

      this.prevIndex = settledIndex
      this.pendingIndex = settledIndex
      this.isTransitioning = false
    }

    handleTransitionClick(event) {
      if (!this.isTransitioning) return
      const link = event.target.closest('.f-slideshow__btn-group a')
      if (link && this.contains(link)) {
        event.preventDefault()
        event.stopPropagation()
      }
    }

    playVideo() {
      this.pauseAllMedia()
      const selectedElm = this.slider.selectedElement
      const deferredMedia = selectedElm.querySelector('deferred-media')
      if (deferredMedia) {
        deferredMedia.loadContent()
        const youtube = deferredMedia.querySelector('.js-youtube')
        const vimeo = deferredMedia.querySelector('.js-vimeo')
        const video = deferredMedia.querySelector('video')
        if (video) video.play()
        if (youtube) youtube.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*')
        if (vimeo) vimeo.contentWindow.postMessage('{"method":"play"}', '*')
      }
    }

    pauseAllMedia() {
      this.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*"
        );
      });
      this.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      this.querySelectorAll("video").forEach((video) => video.pause());
    }

    handleScreenChange() {
      if (FoxThemeSettings.isMobile) {
        // this.domNodes.flickity.toggleFade()
      }
      document.addEventListener('matchMobile', () => {
        // this.domNodes.flickity.toggleFade()
      })
      document.addEventListener('unmatchMobile', () => {
        // this.domNodes.flickity.toggleFade(true)
      })
    }
  }

  customElements.define('slideshow-component', SlideshowComponent)
}